<template>
  <!--团队测评 -->
  <div class="section">
    <div style="padding-top: 5px">
      <div style="margin-top: 150px; width: 80%; margin-left: 125px">
        <detailTable
          :model="model"
          :result="result"
          :detail="detail"
          :maxScore="maxScore"
          :minScore="minScore"
          :maxName="maxName"
          :title="title"
        />
      </div>
      <div
        style="
          color: white;
          font-size: 30px;
          font-weight: bold;
          margin-top: 55px;
          margin-left: 40px;
          line-height: 30px;
        "
      >
        {{ this.maxName }}
      </div>

      <div
        style="
          width: 300px;
          margin: 130px 50px 0 0;
          float: right;
          letter-spacing: 1px;
          line-height: 25px;
        "
        v-html="content1"
      ></div>
      <!-- <div style="width:300px;margin: 430px 50px 0 0;float:right;">
      {{ content2 }}
    </div> -->
      <div style="margin-top: 90px; float: left; margin-left: 20px">
        <teamLatitudeRadar :result="result" :model="model" />
      </div>

      <div
        style="
          width: 300px;
          padding-top: 550px;
          margin-left: 100px;
          letter-spacing: 1px;
          line-height: 25px;
        "
      >
        {{ content2 }}
      </div>
    </div>
  </div>
</template>

<script>
import detailTable from "@/components/dataView/table/team/detailTable.vue";
import teamLatitudeRadar from "@/components/dataView/echarts/team/teamLatitudeRadar.vue";
export default {
  props: ["model", "result", "teamDescribe"],
  components: { detailTable, teamLatitudeRadar },
  data() {
    return {
      content1: "",
      // content2: chuangxin.content2,
      content2: "",
      detail: [],
      max: [],
      maxScore: 0,
      minScore: 0,
      maxName: "",
      min: [],
      title: [
        "实干者",
        "协调者",
        "推进者",
        "创新者",
        "信息者",
        "监督者",
        "凝聚者",
        "完善者",
        "专家型",
      ],
    };
  },
  mounted() {
    if (this.model) {
      this.loadTitle();
    }
  },
  watch: {
    model(val) {
      this.loadTitle();
    },
  },
  methods: {
    loadTitle() {
      this.detail = [];
      this.title.map((item, index) => {
        this.detail.push({
          name: item,
          score: this.result[index],
        });
        if (this.result[index] == Math.max(...this.result)) {
          this.max.push({
            name: item,
            score: this.result[index],
          });
          this.maxName = item;
          this.maxScore = this.result[index];
        } else if (this.result[index] == Math.min(...this.result)) {
          this.min.push({
            name: item,
            score: this.result[index],
          });
          this.minScore = this.result[index];
        }
      });
      //后加的结果
      this.teamDescribe.map((item) => {
        if (item.key == this.maxName) {
          this.content1 = item.roleText.contribution;
          this.content2 = item.roleText.weakness;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.section {
  page-break-before: always;
  page-break-after: always;
  page-break-inside: avoid;

  height: 1124px; //A4纸的高度像素
  background-size: 100% 100%;
  background-image: url("../../../../assets/images/team/back11.png");
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/report/three/team/pageFour.vue